export default {
   url: 'http://test.accounts.cms.gov/v1/',
   timeout: 1000,
}